import React, { useState, useEffect} from 'react'
//Bibliotecas
import styled from 'styled-components';

//Componentes
import FlexContainer from '../common/FlexContainer'
//Imágenes
import { X, Check, HelpCircle } from 'react-feather';
import { CustomButton } from '../common/Button';

const getAswers = (questions) => {
    let answers = [];
    questions.forEach((question) => {
        answers.push({ value: `${question.answer}`, label: `${question.answer}` });
    })
    return answers;
}

// Barajar array - Algoritmo Fisher-Yates
const shuffle = (arr) => {
    const array = arr.slice(0);
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

function ActividadRelacionar({ data, isOk, setIsOk, pistas, setPistas}) {
    //Estados
    const [questions, setQuestions] = useState(shuffle(data));
    const [answers, setAnswers] = useState(shuffle(getAswers(questions)));
    const [events, setEvents] = useState(['click']);

    useEffect(() => {
        setPistas(0);
        setIsOk(false);
    }, [setIsOk, events])


    function checkOk() {
        const items = document.querySelectorAll('.select-answer');
        setIsOk(true);
        items.forEach((item, index) => {
            if (item.value !== questions[index].answer) {
                setIsOk(false);
            }
        })
    }

    const checkAnswers = () => {
        setPistas(pistas+1);
        const items = document.querySelectorAll('.select-answer');
        items.forEach((item, index) => {
            if (item.value == questions[index].answer) {
                item.classList.remove('wrong');
                item.classList.add('ok');
            } else {
                item.classList.remove('ok');
                item.classList.add('wrong');
            }
        })
    }

    const Items = (
        <Wrapper>
            {questions.map((question, index) =>
                <Item key={index}>
                    <div className='question'>
                        <div className='image-container'>
                            <img src={question.url}></img>
                        </div>
                        <span>{question.text}</span>
                    </div>
                    <select className='select-answer'>
                        {answers.map((answer, index) =>
                            <option value={answer.value} key={index}>{answer.value}</option>
                        )}
                    </select>
                    <div className='icons'>
                        <X />
                        <Check />
                    </div>
                </Item>
            )}
        </Wrapper>
    );

    return (
        <FlexContainer minHeight='100vh' backgroundColor='transparent' onClick={checkOk}>
            <Info>
                <h1>Actividad</h1>
                <p>Empareja las definiciones con su respectivo concepto</p>
                <CustomButton onClick={checkAnswers}><HelpCircle />Obtener una pista</CustomButton>
            </Info>
            {Items}
        </FlexContainer>
    )
}

export default ActividadRelacionar

const Wrapper = styled.div`
   width:80%;
   margin:64px;
   text-align:left;
`;

const Info = styled.div`
   margin-top:64px;
   display:flex;
   flex-direction:column;
   align-items:center;
   color: var(--color-blanco);
   h1{
        color:var(--color-azul-claro);
   }

`;

const Item = styled.div`
    box-sizing:border-box;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    padding:16px;
    color:var(--color-blanco);
    background-color:var(--color-morado-claro);
    border-radius:10px;
    margin:16px;
    box-shadow: 20px 20px 40px rgba(0, 0, 0, 0.25);
    align-items:center;

    .icons svg{
        display:none;
        max-width:32px;
        margin-left:8px;
    }

    .question{
        display:flex;
        align-items:center;
        min-width:70%;
        .image-container{
            width:20%;
            display:flex;
            justify-content:center;
            margin-right:24px;
            img{
                max-height:100px;
            }
        }

        span{
            width:70%;
        }
    }

    .select-answer{
        width:100%;
        color: var(--color-morado-oscuro);
        background-color:var(--color-gris-claro);
        padding:8px;
        border-radius: 5px;
        border: 3px solid var(--color-morado-oscuro);
        font-weight:700; 

        option{
            color: var(--color-negro);
        }
        
    }


    .ok{
       border:3px solid var(--color-exito);
       border-radius:5px;
        ~.icons{
            svg:nth-child(2) {
                 display: block;
            }
        }
     
    }

    .wrong{
        border:3px solid var(--color-error);
        border-radius:5px;
        ~.icons{
            svg:nth-child(1) {
                 display: block;
            }
        }
    }

`;